// import {post, postfile, downFile} from './http'
import {post} from './http'
const baseUrl = '/api/capwhale/center'

// 取消订单
export const cancelMyOrderInfo = v => post(`${baseUrl}/cancelMyOrderInfo`, v.data, v.success, v.error)
//取消订单（活动）
export const cancelEventOrderByEnroll = v => post(`${baseUrl}/cancelEventOrderByEnroll`, v.data, v.success, v.error)

// 获取订单所有的列表
export const getAllOrders = v => post(`${baseUrl}/getAllOrders`, v.data, v.success, v.error)

// 获取个人中心我的收藏相关接口列表
export const getMyCollectlist = v => post(`${baseUrl}/getMyCollectlist`, v.data, v.success, v.error)

// 获取个人中心我关注的列表
export const getMyFollowHostList = v => post(`${baseUrl}/getMyFollowHostList`, v.data, v.success, v.error)

// 查看订单详情
export const getOrderDetail = v => post(`${baseUrl}/getOrderDetail`, v.data, v.success, v.error)

// 获取用户全部课程列表
export const getUserAllCourseList = v => post(`${baseUrl}/getUserAllCourseList`, v.data, v.success, v.error)
// 用户已加入课表列表
export const getUserJoinCourseList = v => post(`${baseUrl}/getUserJoinCourseList`, v.data, v.success, v.error)

// 获取用户统计信息
export const getUserStatisticsInfo = v => post(`${baseUrl}/getUserStatisticsInfo`, v.data, v.success, v.error)
// 加入课程操作
export const operateJoinCourse = v => post(`${baseUrl}/operateJoinCourse`, v.data, v.success, v.error)
// 获取用户基本信息
export const getUserCustomerInfo = v => post(`${baseUrl}/getUserCustomerInfo`, v.data, v.success, v.error)
export const updateUserCustomerInfo = v => post(`${baseUrl}/updateUserCustomerInfo`, v.data, v.success, v.error)
export const updateCourseListIstop = v => post(`${baseUrl}/updateCourseListIstop`, v.data, v.success, v.error)
export const getUserDoExamRecordList = v => post(`${baseUrl}/getUserDoExamRecordList`, v.data, v.success, v.error)
export const getAllQuestionbankByUser = v => post(`${baseUrl}/getAllQuestionbankByUser`, v.data, v.success, v.error)
export const getUploadParam = v => post(`/api/upload/getFileUploadFormInfo`, v.data, v.success, v.error)

//获取票券详情(订单进入)
export const getEventOrderDetail = v => post(`${baseUrl}/getEventOrderDetail`, v.data, v.success, v.error)
//获取我的票券列表
export const getEventGettedTickets = v => post(`${baseUrl}/getEventGettedTickets`, v.data, v.success, v.error)
//获取票券详情（票券列表进入）
export const getEventOrderTicket = v => post(`${baseUrl}/getEventOrderTicket`, v.data, v.success, v.error)
//获取活动票券列表
export const getMyEventTickets = v => post(`${baseUrl}/getMyEventTickets`, v.data, v.success, v.error)
// 获取我的成就列表
export const getMyCertInfo = v => post(`${baseUrl}/getMyCertInfo`, v.data, v.success, v.error)
// 获取已领取的兑换码列表
export const getExistingRedeemcodeList = v => post(`${baseUrl}/getExistingRedeemcodeList`, v.data, v.success, v.error)
// 验证兑换码返回商品信息
export const validationRedeemcodeInfo = v => post(`${baseUrl}/validationRedeemcodeInfo`, v.data, v.success, v.error)
// 提交兑换码信息
export const uploadRedeemcodeInfo = v => post(`${baseUrl}/uploadRedeemcodeInfo`, v.data, v.success, v.error)
